import * as React from "react";
import Box from "@mui/material/Box";
import Avatar from "@mui/material/Avatar";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import IconButton from "@mui/material/IconButton";
import Tooltip from "@mui/material/Tooltip";
import UpdateCurrency from "./UpdateCurrency";
import DeleteCurrency from "./DeleteCurrency";

export default function AccountMenu({ id, setIsWaiting, getData }) {
    const [anchorEl, setAnchorEl] = React.useState(null);
    const open = Boolean(anchorEl);

    const handleClick = (event) => {
        setAnchorEl(event.currentTarget);
    };

    const handleClose = () => {
        setAnchorEl(null);
    };

    // Prevent menu from closing on hover or interaction within the menu
    const handleMenuClick = (event) => {
        event.stopPropagation();
    };

    return (
        <React.Fragment>
            <Box>
                <Tooltip title="Action">
                    <IconButton
                        onClick={handleClick}
                        size="small"
                        sx={{ textAlign: "center" }}
                        aria-controls={open ? "account-menu" : undefined}
                        aria-haspopup="true"
                        aria-expanded={open ? "true" : undefined}
                    >
                        <Avatar sx={{ width: 32, height: 32 }}>A</Avatar>
                    </IconButton>
                </Tooltip>
            </Box>
            <Menu
                anchorEl={anchorEl}
                id="account-menu"
                open={open}
                onClose={handleClose}
                PaperProps={{
                    elevation: 0,
                    sx: {
                        overflow: "visible",
                        filter: "drop-shadow(0px 2px 8px rgba(0,0,0,0.32))",
                        mt: 1.5,
                        "& .MuiAvatar-root": { width: 32, height: 32, ml: -0.5, mr: 1 },
                        "&:before": {
                            content: '""',
                            display: "block",
                            position: "absolute",
                            top: 0,
                            right: 14,
                            width: 10,
                            height: 10,
                            bgcolor: "background.paper",
                            transform: "translateY(-50%) rotate(45deg)",
                            zIndex: 0,
                        },
                    },
                }}
                transformOrigin={{ horizontal: "right", vertical: "top" }}
                anchorOrigin={{ horizontal: "right", vertical: "bottom" }}
                onClick={handleMenuClick} // Prevent close on menu item interaction
            >
                <MenuItem onClick={handleMenuClick}>
                    <UpdateCurrency id={id} handleMenuClose={handleClose} getData={getData}/>
                </MenuItem>
                <MenuItem onClick={handleMenuClick}>
                    <DeleteCurrency id={id} setIsWaiting={setIsWaiting} handleMenuClose={handleClose} getData={getData}/>
                </MenuItem>
            </Menu>
        </React.Fragment>
    );
}
